// frontend/src/utils/authFetch.js
// Thin wrapper around fetch() that injects the auth-token header for calls to
// our own backend (e.g. /event-wizard/*). Response handling stays with the
// caller (some endpoints return JSON, others text/XML).
// Do NOT use this for direct-to-CDN/S3/node URLs — adding the header there
// would trigger CORS preflight and break those requests.

export function authFetch(url, options = {}) {
  const token = localStorage.getItem('auth-token');
  // Optional timeoutMs: aborts the request after N ms. Status polls MUST use
  // this — the browser caps concurrent connections per origin (~6), and a
  // single slow instance (controller blocked in execSync during prepare,
  // box mid-restart) left hanging request(s) that queued every later poll
  // behind them: badges froze until a page reload killed the connections.
  const { timeoutMs, ...rest } = options;
  let signal = rest.signal;
  if (timeoutMs && !signal) {
    const ctrl = new AbortController();
    setTimeout(() => ctrl.abort(), timeoutMs);
    signal = ctrl.signal;
  }
  return fetch(url, {
    ...rest,
    signal,
    headers: {
      ...(rest.headers || {}),
      'auth-token': token,
    },
  });
}
